import React, { useEffect, useState } from "react";
import { Modal, Button, Table, Spinner } from "react-bootstrap";
import { getFacturasbyLiq } from "../../../../api/ordenesDePagoApi";
import {
  FiEdit,
} from "react-icons/fi";
import { formatMiles } from "../../../../utils/miles";
const ModalFacturasProfesionales = ({ estado, onCloseModal, idliquidacion, onEditFactura }) => {
  const [loading, setLoading] = useState(false);
  const [facturas, setFacturas] = useState([]);

  useEffect(() => {
    if (estado) {
      setLoading(true);
      getFacturasbyLiq(idliquidacion)
        .then(setFacturas)
        .catch((e) => console.error(e))
        .finally(() => setLoading(false));
    }
  }, [estado, idliquidacion]);

  return (
    <Modal show={estado} onHide={onCloseModal} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Facturas Profesionales</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <div className="text-center"><Spinner animation="border" /></div>
        ) : facturas.length === 0 ? (
          <p className="text-muted">No hay facturas registradas.</p>
        ) : (
             <Table responsive size="sm" className="mb-0">
            <thead>
              <tr>
               
                <th>Prof.</th>
                <th>Nro Factura</th>
                <th>Monto</th>
                <th>Opciones</th>
              </tr>
            </thead>
            <tbody>
              {facturas.map((f, idx) => (
                <tr key={f.idfacturasprofesionales}>
                
                  <td>{f.NombreUsuario}</td>
                  <td>{f.numerofactura}</td>
                  <td className="text-end">{formatMiles(Number(f.monto))}</td>
                  <td className="text-center">
                    <Button
                      size="sm"
                      variant="outline-warning"
                      onClick={() => {
                        onCloseModal(); // cerrar lista
                        onEditFactura(f); // abrir modal de edición
                      }}
                    >
                      <FiEdit />
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={onCloseModal}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalFacturasProfesionales;
